export function OverviewWidget ({module, widgetName, addedByPerson, coordinates, props}) {
  this.module = module
  this.widgetName = widgetName
  this.addedByPerson = addedByPerson
  this.coordinates = coordinates
  this.props = props
}
